import { type PortableTextComponentProps } from '@portabletext/react'

import { getYouTubeVideoId } from '@lib/video'

type VideoEmbedType = 'youtube'

interface SanityVideoEmbed {
  type: VideoEmbedType
  youtubeVideoUrl: string
}

const VideoEmbed = ({
  value,
}: PortableTextComponentProps<SanityVideoEmbed>) => {
  const { type, youtubeVideoUrl } = value

  switch (type) {
    case 'youtube': {
      const youtubeVideoId = getYouTubeVideoId(youtubeVideoUrl)

      if (!youtubeVideoId) {
        return null
      }

      return (
        <div className="relative w-full pt-[calc((9/16)*100%)]">
          <div className="absolute inset-0">
            <iframe
              src={`https://www.youtube.com/embed/${youtubeVideoId}`}
              title="YouTube video player"
              allow="encrypted-media"
              allowFullScreen
              width="100%"
              height="100%"
              frameBorder="0"
            ></iframe>
          </div>
        </div>
      )
    }

    default: {
      return null
    }
  }
}

export default VideoEmbed
